"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeInput = exports.CodeInputContainer = exports.KEY_DOT = exports.KEY_MINUS = exports.KEY_EQUAL = exports.KEY_NUMPAD_DOT = exports.KEY_NUMPAD_MINUS = exports.KEY_NUMPAD_PLUS = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const alert_1 = __importDefault(require("../../alert"));
const utils_1 = require("../../../lib/utils");
const theme_1 = __importDefault(require("../../../styles/theme"));
const SpinnerIcon_1 = __importDefault(require("../../../assets/icons/SpinnerIcon"));
const react_code_input_1 = __importDefault(require("./react-code-input"));
const icon_1 = __importDefault(require("../../icon"));
const input_styles_1 = require("../input-styles");
exports.KEY_NUMPAD_PLUS = 107;
exports.KEY_NUMPAD_MINUS = 109;
exports.KEY_NUMPAD_DOT = 110;
exports.KEY_EQUAL = 187;
exports.KEY_MINUS = 189;
exports.KEY_DOT = 190;
exports.CodeInputContainer = styled_components_1.default.div `
  width: fit-content;
`;
const StyledCodeInput = styled_components_1.default(react_code_input_1.default) `
  display: block;
  width: fit-content;
  margin: auto;

  input {
    ${input_styles_1.inputStyles}
    ${input_styles_1.inputFieldStyles}
    ${(props) => {
    if (props.className === 'success') {
        return `border: 1px ${theme_1.default.colors.primaryAccent} solid;`;
    }
    return '';
}}
    margin-right: 15px;
    height: 44px;
    width: 38px;
    border-radius: 3px;
    font-size: 25px;
    font-weight: ${theme_1.default.font.weight.light};
    text-align: center;
    padding: 10px 6px;
  }
  input:focus-visible {
    ${(props) => {
    if (props.className !== 'pending') {
        return `border: 1px ${theme_1.default.colors.primaryAccent} solid;`;
    }
    return '';
}}
  }

  /* Hiding arrows in numeric inputs for Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Hiding arrows in numeric inputs for Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
const StyledIcon = styled_components_1.default(icon_1.default) `
  position: relative;
`;
const StyledSpinnerIcon = styled_components_1.default(SpinnerIcon_1.default) `
  position: relative;
  top: 2px;
  left: 4px;
`;
const StyledAlert = styled_components_1.default(alert_1.default) `
  text-align: center;
  margin: auto;
  margin-top: 13px;
  position: relative;
  left: -7.5px;
`;
const CodeInput = (_a) => {
    var { onChange = utils_1.noop, fields = 5, state = 'default', errorMessage = 'Incorrect code. Please try again.', value = '', innerRef, onBlur, onFocus, onClick, required, type = 'number', pattern = '[0-9]*', inputMode = 'numeric', name = 'code-input', filterKeyCodes = [
        exports.KEY_NUMPAD_PLUS,
        exports.KEY_NUMPAD_MINUS,
        exports.KEY_NUMPAD_DOT,
        exports.KEY_EQUAL,
        exports.KEY_MINUS,
        exports.KEY_DOT,
    ] } = _a, props = __rest(_a, ["onChange", "fields", "state", "errorMessage", "value", "innerRef", "onBlur", "onFocus", "onClick", "required", "type", "pattern", "inputMode", "name", "filterKeyCodes"]);
    return (react_1.default.createElement(exports.CodeInputContainer, { "data-testid": "code-input-container", "aria-label": "verification-code" },
        react_1.default.createElement(StyledCodeInput, Object.assign({ fields: fields, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onClick: onClick, type: type, pattern: pattern, inputMode: inputMode, className: state, name: name, value: value, innerRef: innerRef, required: required, disabled: state === 'pending', isValid: state !== 'error', filterKeyCodes: filterKeyCodes }, props)),
        state === 'pending' && (react_1.default.createElement(StyledSpinnerIcon, { size: "24px", inline: true, speed: 900 })),
        state === 'success' && (react_1.default.createElement(StyledIcon, { name: "checkmark", color: theme_1.default.colors.primaryAccent, size: "22px" })),
        state === 'error' && (react_1.default.createElement(StyledAlert, { borderless: true, error: true }, errorMessage))));
};
exports.CodeInput = CodeInput;
exports.default = exports.CodeInput;
